// Resolves the function-form DrugResolutionNode display props against the
// current condition-route context, so action tags / reason lines / callouts can
// be computed per patient. Static values pass through unchanged.

import type { ConditionRouteContext, DrugResolutionNode } from "../types/pathway.types";

export function resolveDrugResolutionNode(
  node: DrugResolutionNode,
  ctx: ConditionRouteContext
): DrugResolutionNode {
  const selectionTags =
    typeof node.selectionTags === "function" ? node.selectionTags(ctx) : node.selectionTags;
  const avoidRequiresReason =
    typeof node.avoidRequiresReason === "function"
      ? node.avoidRequiresReason(ctx)
      : node.avoidRequiresReason;
  const reasonLines =
    typeof node.reasonLines === "function" ? node.reasonLines(ctx) : node.reasonLines;
  const reasonBadges =
    typeof node.reasonBadges === "function" ? node.reasonBadges(ctx) : node.reasonBadges;
  const rowDetails =
    typeof node.rowDetails === "function" ? node.rowDetails(ctx) : node.rowDetails;
  const rowCallouts =
    typeof node.rowCallouts === "function" ? node.rowCallouts(ctx) : node.rowCallouts;
  const selectionPrompt =
    typeof node.selectionPrompt === "function" ? node.selectionPrompt(ctx) : node.selectionPrompt;
  const stored = node.storesTo ? ctx.context[node.storesTo] : undefined;
  const prefilledReason = typeof stored === "string" ? stored : undefined;

  return {
    ...node,
    selectionTags,
    avoidRequiresReason,
    reasonLines,
    reasonBadges,
    rowDetails,
    rowCallouts,
    selectionPrompt,
    prefilledReason,
  };
}
